import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldIcon, PlusIcon, AlertCircleIcon } from 'lucide-react';
export const Dashboard: React.FC = () => {
  // Mock brands data
  const brands = [{
    id: 1,
    name: 'Acme Inc',
    domain: 'acmeinc.com',
    threats: 5,
    lastScan: '2 hours ago'
  }, {
    id: 2,
    name: 'TechGiant',
    domain: 'techgiant.com',
    threats: 2,
    lastScan: '1 day ago'
  }, {
    id: 3,
    name: 'SecureWeb',
    domain: 'secureweb.com',
    threats: 0,
    lastScan: '3 hours ago'
  }];
  return <div className="space-y-6" data-id="element-245">
      <div className="flex items-center justify-between" data-id="element-246">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-247">Dashboard</h1>
        <button className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700" data-id="element-248">
          <PlusIcon className="h-4 w-4 mr-2" data-id="element-249" />
          Add Brand
        </button>
      </div>
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-250">
        {brands.map(brand => <Link key={brand.id} to={`/brand/${brand.id}`} className="block bg-white shadow-sm rounded-lg overflow-hidden hover:shadow-md transition-shadow duration-200" data-id="element-251">
            <div className="p-6" data-id="element-252">
              <div className="flex items-center justify-between" data-id="element-253">
                <h3 className="text-lg font-medium text-gray-900" data-id="element-254">
                  {brand.name}
                </h3>
                {brand.threats > 0 && <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800" data-id="element-255">
                    <AlertCircleIcon className="mr-1 h-3 w-3" data-id="element-256" />
                    {brand.threats} threats
                  </span>}
              </div>
              <p className="mt-2 text-sm text-gray-500" data-id="element-257">{brand.domain}</p>
              <div className="mt-4 flex items-center" data-id="element-258">
                <ShieldIcon className="h-5 w-5 text-blue-500 mr-2" data-id="element-259" />
                <span className="text-xs text-gray-500" data-id="element-260">
                  Last scan: {brand.lastScan}
                </span>
              </div>
            </div>
          </Link>)}
      </div>
      <div className="bg-white shadow-sm rounded-lg p-6" data-id="element-261">
        <h2 className="text-lg font-medium text-gray-900 mb-4" data-id="element-262">
          Recent Alerts
        </h2>
        <div className="border-t border-gray-200 divide-y divide-gray-200" data-id="element-263">
          <Link to="/brand/1/domains/1" className="block py-4 hover:bg-gray-50 transition-colors duration-150" data-id="element-264">
            <div className="flex items-center justify-between" data-id="element-265">
              <div className="flex items-center" data-id="element-266">
                <AlertCircleIcon className="h-5 w-5 text-red-500 mr-3" data-id="element-267" />
                <div data-id="element-268">
                  <p className="text-sm font-medium text-gray-900" data-id="element-269">
                    New high-risk domain detected
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-270">
                    acme-inc.net - similar to acmeinc.com
                  </p>
                </div>
              </div>
              <span className="text-xs text-gray-500" data-id="element-271">2 hours ago</span>
            </div>
          </Link>
          <Link to="/brand/2/domains/2" className="block py-4 hover:bg-gray-50 transition-colors duration-150" data-id="element-272">
            <div className="flex items-center justify-between" data-id="element-273">
              <div className="flex items-center" data-id="element-274">
                <AlertCircleIcon className="h-5 w-5 text-yellow-500 mr-3" data-id="element-275" />
                <div data-id="element-276">
                  <p className="text-sm font-medium text-gray-900" data-id="element-277">
                    New medium-risk domain detected
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-278">
                    techgiant-support.com - similar to techgiant.com
                  </p>
                </div>
              </div>
              <span className="text-xs text-gray-500" data-id="element-279">1 day ago</span>
            </div>
          </Link>
        </div>
      </div>
    </div>;
};